import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getMessageAttachment = async ({ questionNoteId, fileName }) => {
  return await request.get(
    `/Question/note_attachment`,
    { questionNoteId, fileName },
    'При загрузке файла произошла ошибка',
    'Error'
  );
};

const useMessageAttachment = ({ id, questionNoteId, fileName }, options) =>
  useQuery(
    questionsQueryKeys.messageAttachment(id),
    () => getMessageAttachment({ questionNoteId, fileName }),
    options
  );

export default useMessageAttachment;
